interface FetchOptions {
  headers?: Record<string, string>;
  method?: string;
  body?: FormData | object;
  [key: string]: unknown;
}

export async function useAuthFetch<T = unknown>(url: string, options: FetchOptions = {}) {
  try {
    const loading = useState<boolean>("loading", () => false);
    const { locale } = useI18n();
    const token = useCookie("token");

    options.headers = {
      ...options.headers,
      lang: locale?.value || "en",
    };

    // Add Authorization header if token exists and not already provided
    if (token?.value && !options.headers?.Authorization) {
      options.headers = {
        ...options.headers,
        Authorization: `Bearer ${token.value}`,
      };
    }

    if (loading) {
      loading.value = true;
    }
    const res = await useFetch<T>(url, options);
    if (loading) {
      loading.value = false;
    }

    return res;
  } catch (error) {
    console.error("Error in useAuthFetch:", error);
    // Return a safe fallback structure
    return {
      data: ref(null),
      error: ref(error),
      status: ref(null),
    } as ReturnType<typeof useFetch<T>>;
  }
}
